const prevArrowShop = document.querySelector('.swiper-button-prev-shop');
const nextArrowShop = document.querySelector('.swiper-button-next-shop');

$('.b-shop__media-gallery-top').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: '.b-shop__media-gallery-thumbs',
    arrows: true,
    prevArrow: prevArrowShop,
    nextArrow: nextArrowShop,
});

$('.b-shop__media-gallery-thumbs').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: '.b-shop__media-gallery-top',
    dots: true,
    centerMode: true,
    focusOnSelect: true
});